import type { StaticApplicationsFooterBffNavigationDto } from '@ori/static-api-client-react';
import { StaticNavigationNavigationItemDtoLinkType } from '@ori/static-api-client-react';

import { getChildrenWithNavigationType } from './getChildrenWithNavigationType';

export const getPaymentMethods = (footer: StaticApplicationsFooterBffNavigationDto | undefined) => {
  const paymentMethods = getChildrenWithNavigationType(
    StaticNavigationNavigationItemDtoLinkType.PaymentMethods,
    footer,
  );
  const paymentMethodsItems = paymentMethods?.children.filter(
    (item) => item.linkType === StaticNavigationNavigationItemDtoLinkType.PaymentMethod,
  );

  return paymentMethodsItems;
};
